import { render, staticRenderFns } from "./PublisherList.vue?vue&type=template&id=05cdf68a&scoped=true&lang=pug"
import script from "./PublisherList.vue?vue&type=script&lang=js"
export * from "./PublisherList.vue?vue&type=script&lang=js"
import style0 from "./PublisherList.vue?vue&type=style&index=0&id=05cdf68a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cdf68a",
  null
  
)

export default component.exports